import { json } from "react-router-dom";
import Axois from "../utils/axios";


// export const loadTrialBalance = async () => {  
//   let response = await get('ledgers/prepare_trial_balance').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
//   if (response.status === 'failed') throw json({ message: response.message, status: response.status })
//   return response.data;
// }

export const loadFinancialReport = async (id) => {
  switch (id) {
    case 'income-statement':
      let incomeResponse = await Axois.get('reports/financialReports/income_statement').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
      if (incomeResponse.status === 'failed') throw json({ message: incomeResponse.message, status: incomeResponse.status })
      return incomeResponse.data;
    
    case 'balance-sheet':
      let balanceSheetResponse = await Axois.get('reports/financialReports/balance_sheet').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
      if (balanceSheetResponse.status === 'failed') throw json({ message: balanceSheetResponse.message, status: balanceSheetResponse.status })
      return balanceSheetResponse.data;

    case 'owners-equity':
      let equityResponse = await Axois.get('reports/financialReports/equity').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
      if (equityResponse.status === 'failed') throw json({ message: equityResponse.message, status: equityResponse.status })
      return equityResponse.data;
  }
}


export const loadJournalReport = async () => {
  try {
    const response = await Axois.get('reports/journal-reports');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    console.log(err);
  }
}


export const loadGeneralLedger = async () => {
  try {
    const response = await Axois.get('reports/general-report');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    console.log(err);
  }
}

export const loadTrialBalance = async () => {
  try {
    const response = await Axois.get('reports/trial-balance');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    console.log(err);
  }
}


export const loadPartnerLedgerReport = async () => {
  try {
    const response = await Axois.get('reports/partner-ledger');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    console.log(err);
  }
}